import React, { useCallback, useEffect, useMemo, useState, Suspense } from "react";
import {
    deleteItem,
    fetchData,
} from "../../../utils/apiUtils";
import {
    DeleteSingleButton,
} from "../../../helper/ImageFormat";
import DeleteModel from "../../../Components/DeleteModel";
import Breadcrumb from "../../../helper/Breadcrumb";
import { useParams } from "react-router-dom";
import Spinner from "../../../Components/spinner";
import CustomPagination from "../../../helper/Pagination";
import { checkImage } from "../../../helper/ImageFormat";
import ProductMultiAsyncSelect from "../components/ProductAsyncSelect";
import PerPageSelect from "../../../Components/PerPageSelect";
import TableSearch from "../../../Components/TableSearch";
import dateformate from "../../../helper/DateFormate";
import BackButton from "../../../Components/BackButton";
const ProductCollection = () => {
    const { collectionId } = useParams();
    const [loading, setLoading] = useState(true);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [data, setData] = useState([]);
    const [search, setSearch] = useState("");
    const [deleteItemId, setDeleteItemId] = useState({});
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const totalPages = useMemo(() => Math.ceil(totalCount / perPage), [totalCount, perPage]);
    const [isDeleting, setIsDeleting] = useState(false);
    const fetchPaginationData = useCallback(
        async (page = 1, searchQuery = "") => {
            setLoading(true);
            await fetchData(
                "collection-item-pagination",
                { perPage, pageNo: page, search: searchQuery, collectionId: collectionId, type: "PRODUCT" },
                setData,
                setTotalCount,
                setCurrentPage,
                setLoading
            );
        },
        [perPage]
    );
    useEffect(() => {
        const delay = search ? 500 : 0;
        const handler = setTimeout(() => {
            fetchPaginationData(currentPage, search);
        }, delay);
        return () => clearTimeout(handler);
    }, [search, perPage]);

    const selectedProducts = useMemo(() => {
        if (!data || data.length === 0) return [];
        return data
            .filter((item) => item.type === "PRODUCT" && item.product)
            .map((item) => ({
                value: item.product.id,
                label: item.product.name,
                sku: item.product.sku,
                image: item.product.image,
            }));
    }, [data]);
    const handlePageClick = (page) => {
        if (page >= 1 && page <= totalPages) {
            fetchPaginationData(page);
        }
    };
    const breadcrumbdata = [
        { label: "Home", path: "/" },
        { label: "Product Collection", path: "/product-collection" },
    ];
    const Tableheader = [
        "Product Name",
        "Product SKU",
        "Product Image",
        "Updated At",
        "Action"
    ];
    const handleProductSelect = (product) => {
        fetchPaginationData()

    };
    const handleDelete = async (data) => {
        setDeleteItemId(data);
        setDeleteModalOpen(true);
    };
    const confirmDelete = async () => {
        setIsDeleting(true);
        try {
            const res = await deleteItem("collection-item", deleteItemId?.id, fetchPaginationData);
            setDeleteItemId({});
            setDeleteModalOpen(false);
            return res
        } catch (error) {
            return error;
        } finally {
            setIsDeleting(false);
        }
    };
    return (
        <>
            <div className="content-wrapper">
                <div className="page-header mt-5 d-flex justify-content-between">
                    <h3 className="custom-page-title">Collection Products</h3>
                    <Breadcrumb items={breadcrumbdata} />
                </div>

                <div className="d-flex justify-content-between mb-2 bg-white p-2" style={{ marginTop: "-20px" }}>
                  <PerPageSelect value={perPage} onChange={setPerPage}/>

                    <div style={{ display: "flex", gap: "10px" }}>
                        <BackButton/>
                        <TableSearch value={search} onChange={setSearch} />
                        <ProductMultiAsyncSelect
                            onChange={handleProductSelect}
                            parentId={collectionId}
                            value={selectedProducts}
                            endPoint={"/collection-item-add"}
                            type={"PRODUCT"}

                        />
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12 grid-margin stretch-card">
                        <div className="card">
                            <div className="card-body">
                                <div className="table-responsive">
                                    <table className="custom-table table table-striped">
                                        <thead>
                                            <tr>
                                                {Tableheader.map((item, index) => (
                                                    <th className="font-weight-bold " key={index}>
                                                        {item}
                                                    </th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loading ? (
                                                <tr>
                                                    <td colSpan="8" className="text-center">
                                                        <Spinner />
                                                    </td>
                                                </tr>
                                            ) : data.filter(item => item.product).length > 0 ? (
                                                data
                                                    .filter(item => item.product)
                                                    .map((item, id) => (
                                                        <tr key={item.id}>
                                                            <td>{item.product.name}</td>
                                                            <td>{item.product.sku}</td>
                                                            <td>{checkImage(item.product.image)}</td>
                                                            <td>{dateformate(item.updatedAt)}</td>
                                                            {/* <td>{dateformate(item.createdAt)}</td> */}
                                                            <td>
                                                                <DeleteSingleButton
                                                                    item={item}
                                                                    handleDelete={handleDelete}
                                                                    module={"List Inquiry"}
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="8" className="text-center">
                                                        <h4>No catalogues available</h4>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                {data?.length > 0 && (
                                    <CustomPagination
                                        currentPage={currentPage}
                                        totalPages={totalPages}
                                        onPageChange={handlePageClick}
                                        perPage={perPage}
                                        totalCount={totalCount}
                                    />
                                )}
                                <Suspense fallback={<div>Loading...</div>}>
                                    <DeleteModel
                                        deleteModalOpen={deleteModalOpen}
                                        setDeleteModalOpen={() => setDeleteModalOpen(!deleteModalOpen)}
                                        onConfirm={confirmDelete}
                                        itemName="Collection Item"
                                        isDeleting={isDeleting}
                                    />
                                </Suspense>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ProductCollection;
